const routes = {
  // APP ROUTES
  HOME_PAGE: '/',
  NOT_AUTHORIZED: '/not-authorized',

  SITES: '/settings/sites',
  SITE_SETTINGS: '/settings/site-settings',

  FISCAL_CALENDAR: '/settings/fiscal-calendar',
  PAYROLL_CALENDAR: '/settings/payroll-calendar',

  DAY_PARTS: '/settings/day-parts',

  NOTIFICATION_SETTINGS: '/account/notification-settings',
  NOTIFICATION_SETTINGS_CREATE: '/account/notification-settings/create',
  NOTIFICATION_SETTINGS_EDIT: '/account/notification-settings/:id/edit',

  EDIT_COMPANY_LINKS: '/edit-company-links',

  ACTIVITY_LOG: '/activity-log',

  ALL_REPORTS: '/reports',
  CUSTOM_REPORTS: '/reports/custom-reports',
  SCHEDULED_REPORTS_LIST: '/reports/scheduled',
  SCHEDULED_REPORT_DETAILS: '/reports/scheduled/:scheduleId',
  // --

  LOGIN: '/login/callback',
  LABOR_MODULE: '/labor/:laborPage',
  LABOR_RULES: '/settings/labor/labor-rules',
  LABOR_SETTINGS_SCHEDULE: '/settings/labor/labor-settings-schedule',
  LABOR_RULES_EDIT: '/settings/labor/labor-rules/:ruleType/edit',
  INVENTORY_VALUATION_SETTINGS: '/settings/inventory/inventory-valuation',
  TIP_SHARE_SETTINGS: '/settings/labor/tip-share',
  MY_SCHEDULE: '/my-schedule',
  EMERGENCY_CONTACT_FORM: '/account/registration/emergency-contact',
  EMPLOYEE_INFORMATION_FORM: '/account/registration/employee-information',
  EMPLOYEE_CERTIFICATION_FORM: '/account/registration/employee-certification',
  EMPLOYEE_PAGE: '/labor/employees',
  SCHEDULING_MANAGER: '/labor/scheduling/scheduling-manager',
  EMPLOYEE_OVERVIEW_BASE: '/labor/employees/overview',
  EMPLOYEE_OVERVIEW_PAGE: '/labor/employees/overview/:employeeId/',
  EMPLOYEE_OVERVIEW_ALL_ROUTES: '/labor/employees/overview/:employeeId/:tab',
  EMPLOYEE_GENERAL_INFORMATION_PAGE: '/labor/employees/overview/:employeeId/profile',
  EMPLOYEE_CERTIFICATION_PAGE: '/labor/employees/overview/:employeeId/certification',
  EMPLOYEE_EMPLOYMENT_INFORMATION_PAGE: '/labor/employees/overview/:employeeId/employmentInformation',
  EMPLOYEE_JOBCODES_PAGE: '/labor/employees/overview/:employeeId/jobcodes',
  EMPLOYEE_PERMISSIONS_PAGE: '/labor/employees/overview/:employeeId/permissionsAndAccess',
  JOBCODE_CONFIGURATION_PAGE: '/settings/labor/jobconfiguration',
  JOBCODE_CONFIGURATION_FOCUSMODE_BASE: '/settings/labor/jobconfiguration/job',
  JOBCODE_CONFIGURATION_OVERVIEW_PAGE: '/settings/labor/jobconfiguration/job/:jobcodeId',
  JOBCODE_CONFIGURATION_DETAILS: '/settings/labor/jobconfiguration/job/:jobcodeId/details',
  JOBCODE_EMPLOYEES_FOCUSMODE_BASE: '/settings/labor/jobconfiguration/job',
  JOBCODE_EMPLOYEES_OVERVIEW_PAGE: '/settings/labor/jobconfiguration/job/:jobcodeId/employees',
  APPROACHING_OVERTIME_THRESHOLD: '/labor/reports/approaching-overtime-threshold',
  EMPLOYEE_ACA_THRESHOLD_REPORT: '/labor/reports/aca-threshold-report',
  EMPLOYEE_BREAK: '/labor/reports/employee-break',
  GENERIC_PAYROLL_EXPORT: '/labor/reports/generic-payroll-export',
  EMPLOYEE_SALES_PERFORMANCE: '/labor/reports/employee-sales-performance',
  EMPLOYEE_TIP_REPORT: '/labor/reports/employee-tip-report',
  EMPLOYEE_PAYROLL_SUMMARY_REPORT: '/labor/reports/employee-payroll-summary-report',
  GENERIC_PAYROLL_EXPORT_REPORT: '/labor/reports/generic-payroll-export',
  INTERVAL_SALES_AND_LABOR: '/labor/reports/interval-sales-labor-report',
  SHIFT_TRACKER: '/labor/shift-tracker',
  PUNCH_SUMMARY: '/labor/payroll/punch-summary',
  PUNCH_EMPLOYEE_DETAIL_PAGE: '/labor/payroll/punch-summary/:employeeId/profile/:date/date',
  INVENTORY_MODULE: '/inventory/:inventoryPage',
  INVOICES: '/inventory/invoices',
  INVOICE_HISTORY_REPORT: '/inventory/invoice-history-report',
  UNFINALIZED_VENDORS_REPORT: '/inventory/invoice-history-report/unfinalized-vendors',
  UNFINALIZED_GL_ACCOUNTS_REPORT: '/inventory/invoice-history-report/unfinalized-gl-accounts',
  ADD_INVOICE: '/inventory/invoices/add',
  ADD_INVOICE_TEMPLATE: '/inventory/invoices/add-template',
  UPLOAD_INVOICE_CSV: '/inventory/invoices/upload-csv',
  UPLOAD_INVOICE: '/inventory/invoices/upload/:invoiceUploadJobId',
  UPLOAD_INVOICE_INFO_MAPPING: '/inventory/invoices/upload/:invoiceUploadJobId/info-mapping',
  UPLOAD_INVOICE_COLUMN_MAPPING: '/inventory/invoices/upload/:invoiceUploadJobId/column-mapping',
  UPLOAD_INVOICE_ROW_MAPPING: '/inventory/invoices/upload/:invoiceUploadJobId/row-mapping',
  UPLOAD_INVOICE_TOTALS: '/inventory/invoices/upload/:invoiceUploadJobId/totals',
  EDIT_INVOICE_BASE: '/inventory/invoices/edit/',
  EDIT_INVOICE: '/inventory/invoices/edit/:invoiceId',
  VIEW_INVOICE_BASE: '/inventory/invoices/view/',
  VIEW_INVOICE: '/inventory/invoices/view/:invoiceId',
  SALES: '/sales/:salesPage',
  SALES_REFRESH: '/sales/refresh',
  TIP_SHARE_DISTRIBUTION: '/labor/tip-share-distribution',
  VENDORS: '/inventory/vendors',
  ADD_VENDOR: '/inventory/vendors/add',
  EDIT_VENDOR_BASE: '/inventory/vendors/edit/',
  EDIT_VENDOR: '/inventory/vendors/edit/:vendorId',
  VIEW_VENDOR_BASE: '/inventory/vendors/view/',
  VIEW_VENDOR: '/inventory/vendors/view/:vendorId',
  RECIPES: '/inventory/menu/recipes',
  ADD_RECIPE: '/inventory/menu/recipes/add',
  VIEW_RECIPE: '/inventory/menu/recipes/view/:recipeId',
  EDIT_RECIPE: '/inventory/menu/recipes/edit/:recipeId',
  RAW_ITEMS: '/inventory/raw-items',
  TOP_20_ITEM_USAGE_REPORT: '/inventory/top20-item-usage-report',
  INVENTORY_LISTS: '/inventory/counting-and-locations/lists',
  VIEW_INVENTORY_LIST: '/inventory/counting-and-locations/lists/:listId/:listName/view',
  EDIT_INVENTORY_LIST: '/inventory/counting-and-locations/lists/:listId/:listName/edit',
  INVENTORY_LISTS_ALL_ROUTES: '/inventory/counting-and-locations/lists/:listId/:listName/:mode',
  LOCATIONS: '/inventory/counting-and-locations/locations',
  INVENTORY_COUNT_BASE: '/inventory/counting-and-locations/count',
  INVENTORY_COUNT: '/inventory/counting-and-locations/count/lists/:tab',
  INVENTORY_COUNT_LISTS: '/inventory/counting-and-locations/count/lists/start',
  INVENTORY_COUNT_SUBMITTED: '/inventory/counting-and-locations/count/lists/submitted',
  INVENTORY_COUNT_LOCATIONS: '/inventory/counting-and-locations/count/:countId/',
  INVENTORY_COUNT_REVIEW: '/inventory/counting-and-locations/count/:countId/review',
  INVENTORY_COUNT_REVIEW_FINALIZED: '/inventory/counting-and-locations/count/:countId/review/finalized',
  INVENTORY_COUNT_ALL_ROUTES: '/inventory/counting-and-locations/count/:countId/:locationId/:locationName/:mode',
  INVENTORY_COUNT_PREVIEW: '/inventory/counting-and-locations/count/:countId/:locationId/:locationName/preview',
  INVENTORY_COUNT_FINALIZED: '/inventory/counting-and-locations/count/:countId/:locationId/:locationName/finalized',
  INVENTORY_COUNT_REVIEW_LOCATION: '/inventory/counting-and-locations/count/:countId/:locationId/:locationName/review',
  INVENTORY_COUNT_START: '/inventory/counting-and-locations/count/:countId/:locationId/:locationName/start',
  COUNTING_AND_LOCATIONS: '/inventory/counting-and-locations',
  LOCATIONS_ALL_ROUTES: '/inventory/counting-and-locations/locations/:locationId/:locationName/:tab/:mode',
  VIEW_LOCATION: '/inventory/counting-and-locations/locations/:locationId/:locationName/:tab/view',
  EDIT_LOCATION: '/inventory/counting-and-locations/locations/:locationId/:locationName/:tab/edit',
  ADD_RAW_ITEM: '/inventory/raw-items/add',
  EDIT_RAW_ITEM: '/inventory/raw-items/:rawItemId/general-information',
  EDIT_RAW_ITEM_FOCUS_MODE: '/inventory/raw-items/:rawItemId/general-information-focus-mode',
  VIEW_RAW_ITEM_FOCUS_MODE: '/inventory/raw-items/:rawItemId/general-information-focus-mode-view',
  VIEW_INVENTORY_UNITS: '/inventory/raw-items/:rawItemId/receive-and-inventory-units',
  EDIT_INVENTORY_UNITS_FOCUS_MODE: '/inventory/raw-items/:rawItemId/receive-and-inventory-units-focus-mode',
  VIEW_INVENTORY_UNITS_FOCUS_MODE: '/inventory/raw-items/:rawItemId/receive-and-inventory-units-focus-mode-view',
  REPORTING_RECIPE_UNITS: '/inventory/raw-items/:rawItemId/reporting-and-recipes',
  REPORTING_RECIPE_UNITS_FOCUS_MODE: '/inventory/raw-items/:rawItemId/reporting-and-recipes-focus-mode',
  VIEW_REPORTING_RECIPE_UNITS_FOCUS_MODE: '/inventory/raw-items/:rawItemId/reporting-and-recipes-focus-mode-view',
  UNITS_OF_MEASURE: '/inventory/units-of-measure',
  PURCHASE_ORDERS: '/inventory/purchase-orders',
  PURCHASE_ORDER_VIEW: '/inventory/purchase-orders/:id/view',
  PURCHASE_ORDER_CREATE: '/inventory/purchase-orders/create',
  PURCHASE_ORDER_EDIT: '/inventory/purchase-orders/:id/edit',
  PURCHASE_ORDER_ACKNOWLEDGEMENT: '/acknowledgements/:orgId/purchase-order/:id',
  MENU: '/inventory/menu',
  SALES_ITEMS: '/inventory/menu/sales-items',
  MODIFIER_GROUPS: '/inventory/menu/modifier-groups',
  COGS_REPORT: '/inventory/reports/cost-of-goods',
  PERPETUAL_INVENTORY_ON_HAND: '/inventory/reports/perpetual-inventory-on-hand',
  REAL_TIME_INVENTORY: '/inventory/on-hand',
  LOW_STOCK_REPORT: '/inventory/reports/low-stock',
  HOUSE_ACCOUNTS: '/sales/house-accounts',
  HOUSE_ACCOUNT_CREATE: '/sales/house-accounts/create',
  HOUSE_ACCOUNT_FOCUSMODE_BASE: '/sales/house-accounts/account',
  HOUSE_ACCOUNT_DETAILS: '/sales/house-accounts/account/:houseAccountId/details',
  HOUSE_ACCOUNT_ACTIVITIES: '/sales/house-accounts/account/:houseAccountId/',
  HOUSE_ACCOUNT_ALL_ROUTES: '/sales/house-accounts/account/:houseAccountId/*',
  HOUSE_ACCOUNT_STATEMENT: '/sales/house-accounts/:houseAccountId/statement/:statementId',
  HOUSE_ACCOUNT_TRANSACTION: '/sales/house-accounts/:houseAccountId/transaction/:transactionId',
  SALES_DISCOUNT_REPORT: '/sales/reports/discounts',
  SALES_REFUNDS_REPORT: '/sales/reports/refunds',
  SALES_TAX_REPORT: '/sales/reports/taxes',
  SALES_VOID_REPORT: '/sales/reports/voids',
  SALES_PAYMENT_REPORT: '/sales/reports/payments',
  SALES_SUMMARY_REPORT: '/sales/reports/sales-summary',
  SALES_PRODUCT_MIX_REPORT: '/sales/reports/product-mix',
  SALES_PROFIT_LOSS_REPORT: '/sales/reports/profit-loss',
  SALES_COMPARATIVE_SALES_LABOR_REPORT: '/sales/reports/comparative-sales-labor',
  SALES_REVENUE_CENTER_REPORT: '/sales/reports/revenue-centers',
  SALES_JOURNAL_ENTRY: '/sales/reports/journal-entries',
  SALES_POS_EVENT_LOG: '/sales/pos-event-log',
  SALES_TRANSACTION_DETAILS_REPORT: '/sales/transactions',
  FINANCIAL_SHIFT_MANAGER: '/sales/cash-office/financial-shift',
  FINANCIAL_SHIFT_DETAILS: '/sales/cash-office/financial-shift/:shiftId/shift-details',
  FINANCIAL_SHIFT_DECLARATION: '/sales/cash-office/financial-shift/:shiftId/shift-details/shift-declaration',
  SALES_SETTINGS: '/settings/sales/:salesPage',
  SALES_DEFINITIONS_SETTINGS: '/settings/sales/sales-definitions',
  MANAGE_GL_ACCOUNTS: '/settings/gl/manage-gl-accounts',
  GL_ACCOUNT_MAPPING: '/settings/gl/gl-account-mapping',
  SCHEDULE_REPORTS: '/reports/:scheduleReports',
  ADD_SCHEDULE_REPORTS: '/reports/schedule-reports/add/:reportId',
  EDIT_SCHEDULE_REPORTS: '/reports/schedule-reports/edit/:reportId',
  CUSTOM_METRICS: '/settings/custom-metrics',
  CUSTOM_METRICS_FORM: '/settings/custom-metrics/:metricId',
  CENTRALIZED_REPORTS: '/reports',
} as const;

export const baseRoutes = [
  routes.JOBCODE_CONFIGURATION_FOCUSMODE_BASE,
  routes.HOUSE_ACCOUNT_FOCUSMODE_BASE,
  routes.NOTIFICATION_SETTINGS,
  routes.EMPLOYEE_OVERVIEW_BASE,
  routes.INVENTORY_COUNT_BASE,
  routes.PURCHASE_ORDERS,
  routes.INVOICES,
  routes.RECIPES,
  routes.LOCATIONS,
  routes.INVENTORY_LISTS,
  routes.INVENTORY_COUNT,
  routes.PUNCH_SUMMARY,
  routes.SCHEDULED_REPORTS_LIST,
];

// The following routes are for creation or edit workflows during which the site switcher should be disabled
export const siteLevelModifyRoutes = [
  routes.ADD_RAW_ITEM,
  routes.VIEW_INVENTORY_UNITS,
  routes.REPORTING_RECIPE_UNITS,
  routes.EDIT_RAW_ITEM,
  routes.REPORTING_RECIPE_UNITS_FOCUS_MODE,
  routes.EDIT_INVENTORY_UNITS_FOCUS_MODE,
  routes.EDIT_RAW_ITEM_FOCUS_MODE,
  routes.ADD_VENDOR,
  routes.ADD_RECIPE,
  routes.EDIT_SCHEDULE_REPORTS,
];

export type ValidRoute = (typeof routes)[keyof typeof routes];

export default routes;
